import request from "@/utils/request";
import {exportFile} from "@/api/common";

export function getProductBrandPage(params) {
  return request.post('/supply/brand/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function addProductBrand(params) {
  return request.post('/supply/brand', params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function updateProductBrand(params) {
  return request.put('/supply/brand', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function deleteProductBrand(params) {
  return request.delete('/supply/brand', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function disableOrEnableProductBrand(params) {
  return request.post('/supply/brand/batchDisableOrEnable', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

// 品类

export function getProductCategoryTree(params) {
  return request.get('/supply/category/getCategoryTree', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getProductCategoryPage(params) {
  return request.post('/supply/category/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}


export function getAllProductCategoryTree() {
  return request.get('/supply/category/getAllCategoryTree')
    .then((res) => {
      return Promise.resolve(res.data);
    })
}
export function addProductCategory(params) {
  return request.post('/supply/category', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function updateProductCategory(params) {
  return request.put('/supply/category', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function deleteProductCategory(params) {
  return request.delete('/supply/category', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function disableOrEnableProductCategory(params) {
  return request.post('/supply/category/batchDisableOrEnable', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function importCategory(attId) {
  return request.post(`/supply/category/import?attachmentId=${attId}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}


// 产品

export function getProductPage(params) {
  return request.post('/supply/product/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function disableOrEnableProduct(params) {
  return request.post('/supply/product/batchDisableOrEnable', params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function syncProductImage(params) {
  return request.post('/supply/product/syncProductImageUrl', params)
}

export function deleteProduct(params) {
  return request.delete('/supply/product', {params})
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function getChildProductPage(params) {
  return request.post('/supply/product/childProductPage', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function addProduct(params) {
  return request.post('/supply/product', params);
}

export function getProductBySku(sku) {
  return request.get(`/supply/product/getProductBySku/${sku}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function updateProduct(params) {
  return request.put(`/supply/product`, params);
}

export function getEuFreightEvaluate(params) {
  //V2
  return request.get(`/supply/product/euFreightEvaluate/v2`, {params})
    .then((res) => {
      return Promise.resolve(res.data);
    })
  // return request.get(`/supply/product/euFreightEvaluate`, {params})
  //   .then((res) => {
  //     return Promise.resolve(res.data);
  //   })
}

export function getUsFreightEvaluate(params) {
  //v2
  return request.get(`/supply/product/usFreightEvaluate/v2`, {params})
    .then((res) => {
      return Promise.resolve(res.data);
    })
  // return request.get(`/supply/product/usFreightEvaluate`, {params})
  //   .then((res) => {
  //     return Promise.resolve(res.data);
  //   })
}

export function downloadImportUpdateProductTemp(params) {
  exportFile('', params);
}

export function importProduct(attId, productType) {
  return request.post(`/supply/product/importProduct?attachmentId=${attId}&productType=${productType}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function importUpdateProduct(params) {
  return request.post(`/supply/product/importUpdateProduct`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function getProductLabels(params) {
  return request.post(`/supply/product/printSkuLabels`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getListingLabels(params) {
  return request.post(`/supply/shipment/printListingLabels`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getSupplierQuoteList(params) {
  return request.post(`/supply/product/supplierQuoteList`, params)
    .then(res => res.data);
}

export function addSupplierQuote(params) {
  return request.post(`/supply/product/addQuote`, params);
}

export function getSkuAndSkuNameSelect(isEnable = true) {
  return request.get(`/supply/product/select/skuName?isEnable=${isEnable}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}



